import {Component} from '@angular/core';
/**
 * \@title Basic list
 */
export class ListOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'list-overview-example',
  templateUrl: 'list-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ListOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
ListOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ListOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
